import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import county from '../../defaultFieldDefinitions/County';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import postCode from '../../defaultFieldDefinitions/PostCode';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import * as required from '../../required-validators';
import * as max from '../../max-length-validators';

const FieldDefinitionSE = [
  addressee,
  {
    ...postCode,
    required: true,
    maxLength: 6,
    validate: [required.postCode, max.lengthPostCode(6)],
  },
  companyName,
  nameNumber,
  streetName,
  addressLine2,
  townCity,
  county,
];

export default FieldDefinitionSE;
